function StatsComponent(){
    const stats=[
        {count:"5k",label:"Active Students"},
        {count:"10+",label:"Mentors"},
        {count:"200+",label:"Courses"},
        {count:"50+",label:"Awards"}
    ]

    return(
        <section className="bg-richblack-700">
            <div className="flex flex-col gap-10 justify-between w-11/12 max-w-maxContent mx-auto ">
                <div className="grid grid-cols-2 md:grid-cols-4 text-center">
                    {
                        stats.map((data,index) => {
                            return(
                            <div className="flex flex-col py-10" key={index}>
                                <h1 className="text-[30px] font-bold text-richblack-150">{data.count}</h1> 
                                <h2 className="font-semibold text-[16px] text-richblack-5">{data.label}</h2>          
                            </div>
                            )
                           }
                        )
                    }    
                </div>
            </div>
        </section>
    )
}

export default StatsComponent;